export type DoubleSpreadPageConfig = {
  key: 'left' | 'right'
  trimLeft: number
  hideLeft: boolean
  hideRight: boolean
  liveLeft: number
  liveWidth: number
  marginInsideOnLeft: boolean
  verticalBandLeft: number
  insideBandLeft: number
  guidesEnabled: boolean
  gridLeft: number
  gridTop: number
  gridWidth: number
  gridHeight: number
}

/**
 * Geometry for each page half of a double spread: trim position, live area, the outer and inside
 * margin bands, and the column/row grid box. The left page's inside margin is on its right (the
 * spine); the right page's is on its left.
 */
export function buildDoubleSpreadPageConfigs({
  leftTrimLeft,
  rightTrimLeft,
  pageTrimWidth,
  bleedMargin,
  topInset,
  outsideInset,
  insideInset,
  liveHeight,
  showLeftPageGuides,
  showRightPageGuides,
}: {
  leftTrimLeft: number
  rightTrimLeft: number
  pageTrimWidth: number
  bleedMargin: number
  topInset: number
  outsideInset: number
  insideInset: number
  liveHeight: number
  showLeftPageGuides: boolean
  showRightPageGuides: boolean
}): DoubleSpreadPageConfig[] {
  return [
    {
      key: 'left' as const,
      trimLeft: leftTrimLeft,
      hideLeft: false,
      hideRight: true,
      liveLeft: leftTrimLeft + outsideInset,
      liveWidth: pageTrimWidth - outsideInset - insideInset,
      marginInsideOnLeft: false,
      verticalBandLeft: leftTrimLeft,
      insideBandLeft: leftTrimLeft + pageTrimWidth - insideInset,
      guidesEnabled: showLeftPageGuides,
      gridLeft: leftTrimLeft + outsideInset,
      gridTop: bleedMargin + topInset,
      gridWidth: pageTrimWidth - outsideInset - insideInset,
      gridHeight: liveHeight,
    },
    {
      key: 'right' as const,
      trimLeft: rightTrimLeft,
      hideLeft: true,
      hideRight: false,
      liveLeft: rightTrimLeft + insideInset,
      liveWidth: pageTrimWidth - insideInset - outsideInset,
      marginInsideOnLeft: true,
      verticalBandLeft: rightTrimLeft + pageTrimWidth - outsideInset,
      insideBandLeft: rightTrimLeft,
      guidesEnabled: showRightPageGuides,
      gridLeft: rightTrimLeft + insideInset,
      gridTop: bleedMargin + topInset,
      gridWidth: pageTrimWidth - insideInset - outsideInset,
      gridHeight: liveHeight,
    },
  ]
}
